import { render } from "./Loading.vue?vue&type=template&id=c9db8bee"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=c9db8bee&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__